import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_duplicate",
  "use": "micro_duplicate-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_duplicate\"><path d=\"M6 0a1 1 0 0 1 1 1v2H4a1 1 0 0 0-.993.883L3 4v3H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5Zm1 4v2a1 1 0 0 1-1 1H4V4h3Z\" /><path d=\"M9 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7h1v2h5V4H7V3h2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol